import React, { useEffect, useState, useMemo } from 'react';

// Helper function to format time - optimized
const formatTime = (frame, fps) => {
    // Precalculate conversion factors
    const framesPerHour = fps * 3600;
    const framesPerMinute = fps * 60;

    // Calculate time components more efficiently
    const hours = Math.floor(frame / framesPerHour);
    const minutes = Math.floor((frame % framesPerHour) / framesPerMinute);
    const seconds = Math.floor((frame % framesPerMinute) / fps);

    // Format strings
    const minutesStr = String(minutes).padStart(2, '0');
    const secondsStr = String(seconds).padStart(2, '0');

    return hours > 0
        ? `${hours}:${minutesStr}:${secondsStr}`
        : `${minutesStr}:${secondsStr}`;
};

export default function TimeDisplay({ durationInFrames, fps, playerRef }) {
    const [time, setTime] = useState(0);

    useEffect(() => {
        const player = playerRef.current;
        if (!player) return;

        const onTimeUpdate = () => {
            setTime(player.getCurrentFrame());
        };

        player.addEventListener('frameupdate', onTimeUpdate);

        return () => {
            player.removeEventListener('frameupdate', onTimeUpdate);
        };
    }, [playerRef]);

    // Memoize formatted values to avoid recalculating on every render
    const formattedCurrentTime = useMemo(() => formatTime(time, fps), [time, fps]);
    const formattedDuration = useMemo(() => formatTime(durationInFrames, fps), [durationInFrames, fps]);

    return (
        <h3 className="flex items-center gap-2 font-medium">
            <span>{formattedCurrentTime}</span>
            <span>/</span>
            <span className="opacity-75">{formattedDuration}</span>
        </h3>
    );
}